import React from 'react';
import HeroSection from '../sections/heroSection';
import ClientList from '../sections/clientList';

const Clients = (props) => {
    const body = document.body;
    body.classList = 'template-cients';

    const content = {
        "heroSection":{
            "enable": true,
            "title":"OUR CLIENTELE",
            "subtext":"<strong>Creating a distinct value</strong><br /> and polishing brand assets<br/> from the inside and out."
        }
    };
    
    return(
        <div className="innerWrapper">
            {content.heroSection.enable && 
                <HeroSection data={ content.heroSection }/>
            }
            <ClientList />
        </div>
    )
}

export default Clients;